import { render, staticRenderFns } from "./file-video.vue?vue&type=template&id=4b84d3aa&scoped=true"
import script from "./file-video.vue?vue&type=script&lang=js"
export * from "./file-video.vue?vue&type=script&lang=js"
import style0 from "./file-video.vue?vue&type=style&index=0&id=4b84d3aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84d3aa",
  null
  
)

export default component.exports